export default __webpack_public_path__ + "static/media/e-com.84f8d83e.svg";